"use strict";

export const inspectionGallery = (images) => ({
    images: JSON.parse(images),
    init() {
        window.Fancybox.bind('[data-fancybox="inspection-gallery"]', {})
    }
});